export const environment = {
  production: false,
  apiUrl: 'https://busincesscenterapidevelopment.azurewebsites.net',
  thisUrl: 'https://devbusinesscenter.azurewebsites.net',
  authenticationServiceUrl: 'https://test-ls-auth-service.azurewebsites.net',
  skipBcJobQueueCheck: true,
  allowBcSuperOrders: true,
  version: '00.11',
  googleAnalyticsId: '',
  azureAdB2C: {
    authority: 'https://lsretailb2c.b2clogin.com/lsretailb2c.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN/v2.0',
    authWellknownEndpointUrl:
      'https://lsretailb2c.b2clogin.com/lsretailb2c.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN/v2.0/.well-known/openid-configuration',
    signupAuthority: 'https://lsretailb2c.b2clogin.com/lsretailb2c.onmicrosoft.com/B2C_1A_SIGNUP_VERIFY/v2.0',
    signupAuthWellknownEndpointUrl:
      'https://lsretailb2c.b2clogin.com/lsretailb2c.onmicrosoft.com/B2C_1A_SIGNUP_VERIFY/v2.0/.well-known/openid-configuration',
    apiscope: 'https://lsretailb2c.onmicrosoft.com/cfae354a-5d07-4eb9-a1b9-79a013e41275/api',
    clientId: 'cdf872ee-3bce-46e6-ab86-5906576a9318',
    bhclaim: 'Business Hub',
  },
};
